import * as yup from "yup";
import { ERRORS } from "../constants/errors";

export const userValidation = yup.object().shape({
    name: yup.string().required(ERRORS.NAME_REQUIRED),
    email: yup.string().required(ERRORS.EMAIL_REQUIRED),
    password: yup.string().required(ERRORS.PASSWORD_REQUIRED),
});

export const updateUserValidation = yup.object().shape({
    name: yup.string().required(ERRORS.NAME_REQUIRED),
    email: yup.string().required(ERRORS.EMAIL_REQUIRED),
    password: yup.string().required(ERRORS.PASSWORD_REQUIRED),
});